// Please set this for deployment !!!!!
// Options [local, dev, staging, uat, prod]
const build = 'prod'
// Options [local, dev, staging, uat, prod]

const apiHostname = build === 'local' ? 'http://localhost:3000' : ''
const companyId = '5b780b639b3370063ed76788'
const googleMapApi = 'AIzaSyAjBbFpg3ZUajBzL7k6gEiurQ2XK-TyEx0'
const timezone = 'Australia/Melbourne'

const jobURL = '/jobs'
const jobLegacyURL = '/v2/jobs'
const jobSelectRangeMaxDay = 182

export {
  build,
  apiHostname,
  companyId,
  googleMapApi,
  jobURL,
  jobLegacyURL,
  jobSelectRangeMaxDay,
  timezone
}
